import config from '@/config';
import type { ApiUrlType } from '@/types/schemaTypes';
import { CustomError } from '@/utils/errors';
import isSSR from '@/utils/isSSR';
import { buildQuery } from '@/utils/url';

const ssrEndpoints = {
  agent: (agentId: number) => `${config.BACKEND.URL}/agents/${agentId}/listings`,
  agency: (agencyId: number) => `${config.BACKEND.URL}/companies/${agencyId}/listings`,
  default: `${config.BACKEND.URL}/listings`,
};

const clientEndpoints = {
  agent: () => '/api/apartments',
  agency: () => `/api/apartments`,
  default: '/api/apartments',
};

export function getApiUrl(filters: ApiUrlType) {
  if (!!filters.agentId && !!filters.companyId) {
    throw new CustomError('Cannot have both agentId and companyId in filters', 400);
  }
  const endpoints = isSSR ? ssrEndpoints : clientEndpoints;
  const baseUrl = filters.agentId
    ? endpoints.agent(filters.agentId)
    : filters.companyId
      ? endpoints.agency(filters.companyId)
      : endpoints.default;
  return `${baseUrl}?${buildQuery(filters)}`;
}
